import React from 'react';
// Components
import StoreMarginsPage from '../../components/StoreMargins/StoreMarginsPage';

const ManageAthleteMargins: React.FC = () => {
  return (
    <StoreMarginsPage
      heading="Manage athlete store margins"
      description="Adjust platform fees for this athlete's store to override the default margins."
    />
  );
};

export default ManageAthleteMargins;
